import { useMutation } from '@redwoodjs/web';

import { showErrorToast, showSuccessToast } from 'src/components/Toasts/toast';
import { VALIDATE_PHONE_NUMBER } from 'src/graphql/mutations/userValidations.mutation';

export const useValidatePhoneNumber = () => {
    const [validatePhoneNumber, { loading: validatingPhoneNumber }] =
        useMutation(VALIDATE_PHONE_NUMBER);

    const onValidatePhoneNumber = async (
        phoneNumber: string,
        onError?: () => void,
        onSuccess?: (phoneNumber: string) => void
    ) => {
        await validatePhoneNumber({
            variables: { phoneNumber },
            onCompleted: ({ validatePhoneNumber }) => {
                if (validatePhoneNumber[0].isValid) {
                    showSuccessToast('This Phone Number is Valid');
                    onSuccess && onSuccess(validatePhoneNumber[0]?.phoneNumber);
                } else {
                    showErrorToast('Please provide a valid contact number.');
                    onError && onError();
                }
            },
            onError: () => {
                showErrorToast('Error Validating the Phone Number');
                onError && onError();
            },
        });
    };

    return { onValidatePhoneNumber, validatingPhoneNumber };
};
